import {
  Bell,
  ChevronRight,
  Download,
  Lock,
  MessageSquareOff,
  Languages,
  Palette,
  Plug,
  ShieldCheck,
  UserX,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'
import { Link } from 'react-router-dom'

import { PageHeader } from '@/app/layouts/PageHeader'
import { useT } from '@/i18n'
import type { MessageKey } from '@/i18n'

interface Entry {
  to: string
  title: MessageKey
  description: MessageKey
  icon: LucideIcon
}

const entries: Entry[] = [
  {
    to: '/settings/account',
    title: 'settings.account',
    description: 'settings.accountDesc',
    icon: ShieldCheck,
  },
  {
    to: '/settings/notifications',
    title: 'settings.notifications',
    description: 'settings.notificationsDesc',
    icon: Bell,
  },
  {
    to: '/settings/privacy',
    title: 'settings.privacy',
    description: 'settings.privacyDesc',
    icon: Lock,
  },
  {
    to: '/settings/muted-words',
    title: 'settings.mutedWords',
    description: 'settings.mutedWordsDesc',
    icon: MessageSquareOff,
  },
  {
    to: '/settings/relations',
    title: 'settings.relations',
    description: 'settings.relationsDesc',
    icon: UserX,
  },
  {
    to: '/settings/display',
    title: 'settings.display',
    description: 'settings.displayDesc',
    icon: Palette,
  },
  {
    to: '/settings/language',
    title: 'settings.language',
    // 这一项的描述在三种语言里是同一串「各语言的原名」：看不懂当前界面
    // 语言的人，正是要靠这一行认出自己的语言。
    description: 'settings.languageDesc',
    icon: Languages,
  },
  {
    to: '/settings/data',
    title: 'settings.data',
    description: 'settings.dataDesc',
    icon: Download,
  },
  {
    to: '/settings/keys',
    title: 'settings.access',
    description: 'settings.accessDesc',
    icon: Plug,
  },
]

/** 设置首页：只是一张目录，每一项是一个独立的子页面。 */
export function SettingsPage() {
  const t = useT()
  return (
    <>
      <PageHeader title={t('settings.title')} />
      <nav aria-label={t('settings.categories')}>
        <ul>
          {entries.map((entry) => (
            <li key={entry.to}>
              <Link
                to={entry.to}
                className="flex items-center gap-4 border-b border-line px-4 py-4 hover:bg-surface-hover"
              >
                <entry.icon className="size-5 shrink-0 text-ink-muted" aria-hidden />
                <span className="min-w-0 flex-1">
                  <span className="block text-[15px] font-bold">{t(entry.title)}</span>
                  <span className="block text-[13px] text-ink-muted">{t(entry.description)}</span>
                </span>
                <ChevronRight className="size-5 shrink-0 text-ink-faint" aria-hidden />
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </>
  )
}
